// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-0e2b0ea3] {\n  border-radius: calc(4px * 2);\n}\n\n.header[data-v-0e2b0ea3] {\n  box-shadow: 0px 2px 4px var(--magic-shadow, rgba(0, 0, 0, 0.4));\n}\n@media (min-width: 1024px) {\n  .header[data-v-0e2b0ea3] {\n    box-shadow: none;\n  }\n}", ""]);
// Exports
module.exports = exports;
